import React, { FC } from 'react';

import { InputNumberProps } from 'antd';
import { Rule } from 'antd/es/form';
import { NamePath } from 'antd/es/form/interface';

import { NumberInputFormItem } from '@/components';

interface IMoneyAmountFormItemProps extends InputNumberProps<number> {
	marginBottom?: number;
	name: NamePath;
	label?: string;
	placeholder?: string;
	rules?: Rule[];
}

export const MoneyAmountFormItem: FC<IMoneyAmountFormItemProps> = ({
	marginBottom = 16,
	label,
	name,
	placeholder = 'Enter Amount',
	rules,
	...rest
}) => {
	const formatter = (value?: number): string => {
		return value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
	};

	return (
		<NumberInputFormItem
			controls={false}
			formatter={formatter}
			label={label}
			marginBottom={marginBottom}
			maxLength={10}
			min={0}
			name={name}
			parser={(value) => Number(value?.replace(/,/g, ''))}
			placeholder={placeholder}
			rules={rules}
			suffix={<>USD</>}
			{...rest}
		/>
	);
};
